import { render } from "./PPIDView.vue?vue&type=template&id=0ca1e448"
import script from "./PPIDView.vue?vue&type=script&lang=js"
export * from "./PPIDView.vue?vue&type=script&lang=js"

import "./PPIDView.vue?vue&type=style&index=0&id=0ca1e448&lang=css"
import "./PPIDView.vue?vue&type=style&index=1&id=0ca1e448&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__